import { ListBase } from 'react-admin';
import { SupplyListLayout } from './SupplyListLayout';

export const SupplyList = () => {
    return (
        <ListBase
            resource="supply"
            perPage={25}
            sort={{ field: 'name', order: 'ASC' }}
        >
            <SupplyListLayout />
        </ListBase>
    );
};
